import moment from 'moment';
import type { ApplicationStatus } from '../../pages/Compliance/Compliance.types';
import type { COMPLIANCE_APPLICATION_STATUS_TYPE } from '../../pages/Compliance/types';
import type { ErrorListOutput } from '../../types';

type Address = {
  street: string;
  shortNameStreet: string;
  addressNumber: string;
  postalCode: string;
  municipality: string;
  state: string;
};

export type ValidateApplicationPolicyReqDto = {
  address: Address;
  buildingUnit?: string;
  email: string;
  firstName: string;
  lastName: string;
  leaseStart: string;
  leaseEnd: string;
  buildingId?: string;
  linkId?: string | null;
  utmSource: string;
};

export interface ValidateApplicationPolicySuccessResponse {
  validateApplicationPolicy: {
    application: {
      id: string;
      status: ApplicationStatus | COMPLIANCE_APPLICATION_STATUS_TYPE;
    };
    linkId: string;
    validation: ErrorListOutput;
    errors: never;
  };
}

export interface ValidateApplicationPolicyErrorResponse {
  validateApplicationPolicy: ErrorListOutput & {
    application: never;
    linkId: never;
    validation: never;
  };
}

export type ValidateApplicationPolicyResponse =
  | ValidateApplicationPolicySuccessResponse
  | ValidateApplicationPolicyErrorResponse;

export const VALIDATE_APPLICATION_POLICY = ({
  address,
  email,
  firstName,
  lastName,
  linkId,
  leaseEnd,
  leaseStart,
  buildingId,
  buildingUnit,
  utmSource,
}: ValidateApplicationPolicyReqDto) => {
  const buildingIdQuery = buildingId ? `buildingId: "${buildingId}",` : '';
  const buildingUnitValue = buildingUnit ? buildingUnit : '';
  const leaseStartValue = moment(leaseStart).format('YYYY-MM-DD');
  const leaseEndValue = moment(leaseEnd).format('YYYY-MM-DD');
  const utmSourceQuery = utmSource ? `utmSource: "${utmSource}",` : '';
  const linkIdQuery = linkId ? `linkId: "${linkId}"` : '';

  return `mutation {
    validateApplicationPolicy(
      input:{
        address: {
          street: "${address.street}",
          shortNameStreet: "${address.shortNameStreet}",
          addressNumber: "${address.addressNumber}",
          postalCode: "${address.postalCode}",
          municipality: "${address.municipality}",
          region: ${address.state}
        },
        buildingUnit: "${buildingUnitValue}",
        email: "${email}",
        firstName: "${firstName}",
        lastName: "${lastName}",
        leaseStart: "${leaseStartValue}",
        leaseEnd: "${leaseEndValue}",
        ${buildingIdQuery}
        ${utmSourceQuery}
        ${linkIdQuery}
      }
    ) {
          ... on ApplicationWithValidationOutput {
              application {
                  id
                  status
              }
              linkId
              validation {
                errors {
                  type
                  message
                }
              }
            }
          ... on ErrorListOutput {
              errors: errors {
                  type
                  message
              }
            }
      }
  }`;
};
